import { postMiniGameChangeAttempt } from "@api/miniGame";
import { queryKeyTurn } from "@dataLayer/user";
import {
  getMiniGameAwardListQuery,
  getMiniGameHistoryQuery,
  getMiniGameMissionsQuery,
  getMiniGamePieceCollectedQuery,
  getMiniGamePrizeCollectionQuery,
  getMiniGameRankingQuery,
  getMiniGameRulesQuery,
  getMiniGameSpinHistoryQuery,
  getMiniGameSpinUserQuery,
  getMiniGameWinnerListQuery,
  miniGameKeys,
} from "@dataLayer/miniGame";

// UI actions
export const setOpenPopupPiece = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_PIECE",
  payload,
});

export const setDataPopupError = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_ERROR",
  payload,
});

export const setDataSpinLeft = (payload) => ({
  type: "MINIGAME_UI/SET_SPIN_LEFT",
  payload,
});

export const setOpenPopupFooter = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_FOOTER",
  payload,
});

export const setOpenPopupIntroGift = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_INTRO_GIFT",
  payload,
});

export const setOpenPopupGivePiece = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_GIVE_PIECE",
  payload,
});

export const setOpenPopupGivePieceSuccess = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_GIVE_PIECE_SUCCESS",
  payload,
});

export const setOpenPopupChangeCoinsSuccess = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_CHANGE_COINS_SUCCESS",
  payload,
});

export const setOpenPopupPuzzle = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_PUZZLE",
  payload,
});

export const setPopupMission = (payload) => ({
  type: "MINIGAME_UI/SET_POPUP_MISSION",
  payload,
});

export const pieceLinkMiniGame = (payload) => ({
  type: "MINIGAME_UI/SET_PIECE_LINK",
  payload,
});

export const confirmPieceLinkMiniGame = (payload) => ({
  type: "MINIGAME_UI/SET_CONFIRM_PIECE_LINK",
  payload,
});

const refetch =
  (queryDef) =>
  async (_dispatch, _getState, { queryClient }) => {
    await queryClient.invalidateQueries(queryDef.queryKey[0]);
    return queryClient.fetchQuery(queryDef);
  };

export const getDataSpinUserMiniGame = () => refetch(getMiniGameSpinUserQuery());
export const getDataSpinAwardMiniGame = () => refetch(getMiniGameSpinUserQuery());
export const getDataMissionMiniGame = () => refetch(getMiniGameMissionsQuery());
export const getDataAwardListMiniGame = () => refetch(getMiniGameAwardListQuery());
export const getDataRankingMiniGame = () => refetch(getMiniGameRankingQuery());
// export const getRuleMiniGame = () => refetch(getMiniGameRulesQuery());
export const getDataPrizeCollectionMiniGame = () =>
  refetch(getMiniGamePrizeCollectionQuery());

export const getDataSpinHistoryMiniGame = (params) => async (_d, _s, { queryClient }) => {
  const def = getMiniGameSpinHistoryQuery(params);
  await queryClient.invalidateQueries(miniGameKeys.spinHistory(params));
  return queryClient.fetchQuery(def);
};

export const getDataPieceCollectedMiniGame = (params) => async (_d, _s, { queryClient }) => {
  const def = getMiniGamePieceCollectedQuery(params);
  await queryClient.invalidateQueries(miniGameKeys.pieceCollected(params));
  return queryClient.fetchQuery(def);
};

export const getDataHistoryMiniGame = (params) => async (_d, _s, { queryClient }) => {
  const def = getMiniGameHistoryQuery(params);
  await queryClient.invalidateQueries(miniGameKeys.history(params));
  return queryClient.fetchQuery(def);
};

export const getDataListWinnerMiniGame = (params) => async (_d, _s, { queryClient }) => {
  const def = getMiniGameWinnerListQuery(params);
  await queryClient.invalidateQueries(miniGameKeys.winnerList(params));
  return queryClient.fetchQuery(def);
};

export const getDataListWinnerPastMiniGame = (params) => async (_d, _s, { queryClient }) => {
  const def = getMiniGameWinnerListQuery({ ...params, past: 1 });
  return queryClient.fetchQuery(def);
};

export const changeAttemptByBidMiniGame =
  ({ callback, bid_number } = {}) =>
    async (_dispatch, _getState, { queryClient }) => {

      // Fix: dùng if thay vì optional chaining expression
      if (callback) callback(null, true);

      let data;
      let dataError;

      try {
        data = await postMiniGameChangeAttempt({ bid_number });
      } catch (err) {
        data = { success: false };
        dataError = {
          errorMessage: err?.message || "Request failed",
        };
      }

      // Fix
      if (callback) callback(data, false, dataError);

      if (data?.success) {
        await queryClient.invalidateQueries(miniGameKeys.spinUser);
        await queryClient.invalidateQueries(queryKeyTurn);
        await queryClient.fetchQuery(getMiniGameSpinUserQuery());
      }
    };

/** @deprecated use queryClient.invalidateQueries(queryKeyTurn) via this helper */
export const getTurnRemain = () => async (_d, _s, { queryClient }) => {
  await queryClient.invalidateQueries(queryKeyTurn);
  await queryClient.invalidateQueries(miniGameKeys.spinUser);
};
